export * from './managementAiPresetController.service';
import { ManagementAiPresetControllerService } from './managementAiPresetController.service';
export * from './managementAiPriceController.service';
import { ManagementAiPriceControllerService } from './managementAiPriceController.service';
export * from './managementTranslationController.service';
import { ManagementTranslationControllerService } from './managementTranslationController.service';
export const APIS = [ManagementAiPresetControllerService, ManagementAiPriceControllerService, ManagementTranslationControllerService];
